import { FilledInput, FilledInputProps, Stack, Typography } from '@mui/material'
import { FC, useCallback, useState } from 'react'
import { PaymentProvider } from '../../third-party/PaymentProvider'

const CardExpiryInput: FC<CardExpiryInputProps> = (props) => {
  const { name = 'cardExpiry' } = props

  const [month, setMonth] = useState('')
  const [year, setYear] = useState('')

  const handleMonthChange: Required<FilledInputProps>['onChange'] = useCallback(
    (e) => {
      setMonth(e.target.value)
    },
    []
  )

  const handleYearChange: Required<FilledInputProps>['onChange'] = useCallback(
    (e) => {
      setYear(e.target.value)
    },
    []
  )

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <FilledInput
        required
        id={PaymentProvider.formIds.CARD_EXPIRY_MONTH}
        onChange={handleMonthChange}
        slotProps={{
          input: {
            minLength: 1,
            maxLength: 2,
            pattern: '\\d+',
          },
        }}
      />
      <Typography>/</Typography>
      <FilledInput
        required
        id={PaymentProvider.formIds.CARD_EXPIRY_YEAR}
        onChange={handleYearChange}
        slotProps={{
          input: {
            minLength: 4,
            maxLength: 4,
            pattern: '\\d+',
          },
        }}
      />
      <input type="hidden" name={name} value={`${month}/${year}`} />
    </Stack>
  )
}

type CardExpiryInputProps = {
  name?: string
}

export { CardExpiryInput }
export type { CardExpiryInputProps }
